module.exports = __webpack_public_path__ + "media/images/default/homepage/experience/stethoscope-aa781d9320b0a93c04fe8d8987c6e98e.svg";